module.exports = __webpack_public_path__ + "assets/images/JPY1000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JPY1000.png
// module id = 1408
// module chunks = 1